<template>
    <footer class="bg-cover bg-center text-white py-10 main-back">
      <div class="py-2 px-6 max-w-screen-2xl mx-auto">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <!-- Logo & Socials -->
          <div>
            <img src="@/assets/images/LOGO RESIZE (1).png" alt="Mshel Homes Logo" class="w-24 mb-4" />
            <p class="text-sm hidden md:block">
              At Mshel Homes, we are dedicated to turning real estate dreams into reality. Our passion for quality craftsmanship and personalized designs ensures every home depicts comfort and style.
            </p>
            <div class="flex gap-2 mt-4">
              <a href="https://www.facebook.com/MshelHomes/" class="p-2 w-8 h-8 flex items-center justify-center border border-white rounded-full hover:bg-yellow hover:text-white hover:border-none">
                <i class="fa-brands fa-facebook"></i>
              </a>
              <a href="https://www.linkedin.com/company/mshel-homes-limited" class="p-2 w-8 h-8 flex items-center justify-center border border-white rounded-full hover:bg-yellow hover:text-white hover:border-none">
                <i class="fa-brands fa-linkedin"></i>
              </a>
              <a href="https://www.youtube.com/@mshelhomes" class="p-2 w-8 h-8 flex items-center justify-center border border-white rounded-full hover:bg-yellow hover:text-white hover:border-none">
                <i class="fa-brands fa-youtube"></i>
              </a>
              <a href="https://www.instagram.com/mshelhomes/" class="p-2 w-8 h-8 flex items-center justify-center border border-white rounded-full hover:bg-yellow hover:text-white hover:border-none">
                <i class="fa-brands fa-instagram"></i>
              </a>
              <a href="https://twitter.com/mshelofficial" class="p-2 w-8 h-8 flex items-center justify-center border border-white rounded-full hover:bg-yellow hover:text-white hover:border-none">
                <i class="fa-brands fa-twitter"></i>
              </a>
              <a href="https://www.tiktok.com/@mshelhomes" class="p-2 w-8 h-8 flex items-center justify-center border border-white rounded-full hover:bg-yellow hover:text-white hover:border-none">
                <i class="fa-brands fa-tiktok"></i>
              </a>
            </div>
          </div>
  
          <!-- Address -->
          <div>
            <p class="font-semibold text-lg">Address</p>
            <p class="text-sm mt-6">The Mshel Hub, No. 2 Julius Adelusi Street, Guzape, Abuja.</p>
          </div>
  
          <!-- Email -->
          <div>
            <p class="font-semibold text-lg mb-6">Email</p>
            <a href="mailto:info@mshelhomes.com" class="block text-sm hover:text-yellow-500">info@mshelhomes.com</a>
            <a href="mailto:mshelhomes@gmail.com" class="block text-sm hover:text-yellow-500">mshelhomesltd@gmail.com</a>
          </div>
  
          <!-- Phone -->
          <div>
            <p class="font-semibold text-lg mb-6">Phone</p>
            <a href="tel:+2348104444229" class="block text-sm hover:text-yellow-500">+234-810-444-4229</a>
            <a href="tel:+2348123333326" class="block text-sm hover:text-yellow-500">+234-812-333-3326</a>
          </div>
        </div>
  
        <!-- Footer Bottom -->
        <div class="flex flex-col md:flex-row justify-between items-center mt-10 border-t border-gray-500 pt-4 text-sm">
          <p>© 2025 Mshel Homes. Designed by Mshel Integrated Systems</p>
          <router-link to="/privacy-policy" @click="scrollToTop" class="hover:text-yellow-500">Privacy Policy</router-link>
        </div>
      </div>
    </footer>
  </template>
  
  <script>
  export default {
    name: "FooterComponent",
    methods: {
      scrollToTop() {
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
    },
  };
  </script>  

<style scoped>
.main-back{
    background-image: url("../assets/images/FOOTER.png");
}
</style>